export const displayEnum = (enum_, value) => {
    const value_ = enum_[value];
    if (value_ === undefined) {
        return value_;
    }
    return value_.replaceAll("_", ` `);
};
